// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","note":"BuildTypeChainsTab__note--LF","blocks":"BuildTypeChainsTab__blocks--qw","loadMore":"BuildTypeChainsTab__loadMore--qW"};